<template>
  <div class="card modal-card-panier modal-card-border">
    <div class="card-content">
      <section>
        <p class="subtitle is-5 has-text-centered">Etes-vous sûr de vouloir vider le panier ?</p>
      </section>
      <br>
      <footer>
        <div class="has-text-centered">
          <button class="button is-gris button-modal has-text-centered"
                  @click="$emit('close', false)">
            Annuler
          </button>

            <button class="button is-primary button-modal has-text-centered"
                    @click="$emit('close', true)">
              Vider
            </button>

        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vider-panier',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/viderPanier.vue